import { Inject, Injectable } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { Observable, ReplaySubject } from "rxjs";
import { APP_CONFIG, AppConfig } from "../../core/app-config/app-config.module";

@Injectable({
    providedIn: 'root'
})
export class TitleService {

    pageTitle: ReplaySubject<string> = new ReplaySubject<string>(1);
    private _pageTitle: string = '';

    constructor(
        private windowTitleService: Title,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {
    }

    public setPageTitle(title) {
        this._pageTitle = title;
        this.pageTitle.next(title);
    }

    public setWindowTitle(title) {
        this.windowTitleService.setTitle(title);
    }

    public setWindowAndPageTitle(title) {
        this.setPageTitle(title);
        this.setWindowTitle(title);
    }

    public getPageTitleObservable(): Observable<string> {
        return this.pageTitle.asObservable();
    }

    public getPageTitle(): string {
        return this._pageTitle;
    }

    public getWindowTitle(): string {
        return this.windowTitleService.getTitle();
    }
}
